import { ChatMessage, ChartData } from './types';
import { SESSION_NAMES_KEY } from './constants';

/** Generate a unique message ID. */
export function createMessageId(): string {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

/** Create a ChatMessage object. */
export function createMessage(role: 'user' | 'assistant', content: string, chartData?: ChartData): ChatMessage {
  return { id: createMessageId(), role, content, timestamp: Date.now(), chartData };
}

/** Format a time range into a human-readable label. */
export function formatTimeRangeLabel(range: { startTime: number; endTime: number }): string {
  const hours = Math.round((range.endTime - range.startTime) / (60 * 60 * 1000));
  return hours < 24 ? `last ${hours}h` : `last ${Math.round(hours / 24)}d`;
}

/** Format elapsed seconds into a readable string. */
export function formatElapsed(seconds: number): string {
  return seconds < 60 ? `${seconds}s` : `${Math.floor(seconds / 60)}m ${seconds % 60}s`;
}

/** Save a session name to localStorage. */
export function saveSessionName(sessionId: string, name: string): void {
  try {
    const names = JSON.parse(localStorage.getItem(SESSION_NAMES_KEY) || '{}');
    if (!names[sessionId]) {
      names[sessionId] = name.slice(0, 60);
      localStorage.setItem(SESSION_NAMES_KEY, JSON.stringify(names));
    }
  } catch {
    // Silently ignore localStorage errors
  }
}

/** Convert a Date to a local datetime string for input[type=datetime-local]. */
export function toLocalDateTimeString(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
